"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specialties = ["GRC", "ASM", "CSPM", "TPRM", "Privacy"];
export default function IntegratedCyberSecurity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="integrated-cyber-security" className="py-24 md:py-32 bg-secondary/40 border-y border-border/50">
      <div ref={ref} className={`container mx-auto px-6 max-w-4xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="flex items-center justify-center gap-6 md:gap-8 mb-12">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604077/img/quantificial_logo_dark.png" alt="Quantificial" className="h-7 md:h-8 object-contain opacity-90 grayscale contrast-125 hover:grayscale-0 transition-all duration-500" />
          <div className="flex items-center justify-center size-8 rounded-full bg-background shadow-sm border border-border/60">
            <Plus className="size-4 text-muted-foreground" strokeWidth={1.5} />
          </div>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604077/img/cytrusst_logo_dark.png" alt="Cytrusst" className="h-7 md:h-8 object-contain opacity-90 grayscale contrast-125 hover:grayscale-0 transition-all duration-500" />
        </div>

        {}
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6 tracking-tight">
          Security Built-In, Not Bolted On
        </h2>
        <p className="text-lg text-muted-foreground mb-12 max-w-2xl mx-auto leading-relaxed">
          Security isn't an add-on—it's an integrated layer. Through our partnership with Cytrusst, enterprise-grade protection is built into every AI, data, and platform architecture we deploy from day one.
        </p>

        {}
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {specialties.map((item, i) => <Badge key={item} data-index={i} variant="outline" className="px-5 py-2 text-sm font-medium rounded-full border-border/80 text-muted-foreground bg-background/50 backdrop-blur-sm hover:border-primary/40 hover:text-primary hover:bg-primary/5 hover:shadow-sm transition-all duration-300 cursor-default">
              {item}
            </Badge>)}
        </div>
      </div>
    </section>;
}